import { PropertyLinkedPropertyType, PropertyType } from "../../Types/propertyTypes"

export const isParent = (
    relatedPropertyData: PropertyType | null,
    mainPropertyData: PropertyType | null
) => {
    if (relatedPropertyData && mainPropertyData) {
        const {
            multiUnit: {
                isMultiUnit,
                linkedUnits,
            }
        } = mainPropertyData
        if (isMultiUnit) {
            const parentProperty = linkedUnits.find((unit: PropertyLinkedPropertyType) => {
                return unit.propertyId === relatedPropertyData._id && unit.relationship === 'parent'
            })
            if (parentProperty) {
                return true
            }
        }
    }
    return false
}